import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import MaterialTable from 'material-table'

class AttributeTable extends Component {
  render() {

    if (this.props.data && this.props.data.length===0) return null;
    const record = this.props.data[0];
    const columns = Object.keys(record).filter((key) => key !== 'tableData' && key !== 'record_id').map(
      (key) => {return {title: key, field: key}});

    return (
      <div style={{ maxWidth: '100%' }}>
        <MaterialTable
          columns={columns}
          data = {this.props.data}
          options={{showTitle: false, pageSize:10}}
          localization={{
            pagination: {
                labelDisplayedRows: 'prikazani zapisi {from}-{to} od vseh ({count})',
                labelRowsSelect: 'vrstic'
            },
            toolbar: {
                nRowsSelected: '{0} izbranih vrstic',
                searchTooltip: 'iskanje',
                searchPlaceholder: 'iskanje'
            },
            header: {
                actions: 'Actions'
            },
            body: {
                emptyDataSourceMessage: 'No records to display',
                filterRow: {
                    filterTooltip: 'Filter'
                }
            }
        }}
        />
      </div>
    )
  }
}

export default AttributeTable;